import {NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {WINDOW_PROVIDERS} from './application/window.provider'
import {LOCAL_STORAGE_PROVIDERS} from './application/localstorage.provider'

import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {SpbCommonModule} from './common/common.module'
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {AuthInterceptor} from './application/auth-interceptor'
import '@angular/common/locales/global/fr'
import '@angular/common/locales/global/sv'
import {ThemeModule} from '@sparbanken-syd/sparbanken-syd-theme'

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SpbCommonModule,
    HttpClientModule,
    ThemeModule
  ],
  providers: [
    WINDOW_PROVIDERS,
    LOCAL_STORAGE_PROVIDERS,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
